import { stylesheet } from "typestyle";

const styles = stylesheet({
  attachmentRow: {
    marginBottom: "12px",
  },
});

export default styles;
